module.exports = __webpack_public_path__ + "fb73704625e3e428f79ed22dde11206f.MP3";